const TipoAbitazioneBarriereEnum = {
    ASSENTI: 1,
    ESTERNE: 2,
    INTERNE: 3,
  };
  
  TipoAbitazioneBarriereEnum.getLabel = function (value) {
    switch (value) {
      case this.ASSENTI:
        return "Assenti";
      case this.ESTERNE:
        return "Esterne";
      case this.INTERNE:
        return "Interne";
      default:
        return value;
    }
  };
  
  export default TipoAbitazioneBarriereEnum;





